enum OrderBillingStatuses {
  Unbilled = 1,
  PendingBilling = 2,
  BillingSuccess = 3,
  BillingFailed = 4,
}

export default OrderBillingStatuses;
